/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-05 15:02:57
 * @LastEditTime: 2020-08-14 20:20:37
 * @Description: 帮助函数
 */


export const paymentItemList = [{
	item: 'baoxiao',
	zh: '费用报销'
}, {
	item: 'huokuan',
	zh: '供应商货款'
}, {
	item: 'gongzi',
	zh: '工资和社保'
}, {
	item: 'yunfei',
	zh: '运费'
}, {
	item: 'huankuan',
	zh: '还款本金&利息'
}, {
	item: 'shui',
	zh: '税款'
}, {
	item: 'baozhengjin',
	zh: '保证金'
}, {
	item: 'shuidianfei',
	zh: '水电费'
}, {
	item: 'fangzu',
	zh: '房租'
}, {
	item: 'zhongjie',
	zh: '中介服务费'
}, {
	item: 'zhaodaifei',
	zh: '招待费'
}, {
	item: 'yewufei',
	zh: '业务费'
}, {
	item: 'others',
	zh: '其他'
}, ]

export const typeToText = {
	trans: "银行转账",
	bankAccBill: "银承",
	commAccBill: "商承",
	check: "支票",
	cash: "现金钞票",
	yun: "云信通",
	jian: "建信融通",
	bankAccBillPaper: "纸质银承",
	gold: "金单",
	sywx: "商银微芯",
	ji: "集信",
	zhu: "筑信",
};

export const payToModelToText = {
	Supplier: "供应商",
	User: "员工",
	Customer: "客户",
	Entity: "机构",
	Company: "内部公司",
	baoxiao: "费用报销",
};

export const billStatusToText = {
	waiting: "未到期",
	receive: "到期兑现",
	overdue: "逾期无法兑现",
	paid: "背书给供应商",
	partPaid: "部分支付",
};